// carousels
var CAROUSEL_CONFIG = {
	".carousel__items": {
		loop: false,
		dots: false,
		nav: true,
		lazyLoad: true,
		navText: [
			'<span class="visually-hidden">Předchozí</span><svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true"><path d="M15 5a1 1 0 0 0-.707.293l-6 6a1 1 0 0 0 0 1.414l6 6a1 1 0 0 0 1.414-1.414L10.414 12l5.293-5.293A1 1 0 0 0 15 5z"/></svg>',
			'<span class="visually-hidden">Další</span><svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true"><path d="M9 5a1 1 0 0 0-.707 1.707L13.586 12l-5.293 5.293a1 1 0 0 0 1.414 1.414l6-6a1 1 0 0 0 0-1.414l-6-6A1 1 0 0 0 9 5z"/></svg>'
		],
		merge: true,
		responsiveClass: true,
		responsive: {
			0: {
				items: 2.3,
				margin: 20,
				slideBy: 2
			},
			400: {
				items: 3.3,
				margin: 20,
				slideBy: 3
			},
			575: {
				items: 3,
				margin: 20,
				slideBy: 3
			},
			767: {
				items: 4,
				margin: 20,
				slideBy: 4
			},
			1000: {
				items: 5,
				margin: 25,
				slideBy: 5
			},
			1200: {
				items: 6,
				margin: 25,
				slideBy: 6
			}
		}
	},
	".carousel__modal": {
		loop: false,
		dots: false,
		nav: true,
		lazyLoad: true,
		navText: [
			'<span class="visually-hidden">Předchozí</span><svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true"><path d="M15 5a1 1 0 0 0-.707.293l-6 6a1 1 0 0 0 0 1.414l6 6a1 1 0 0 0 1.414-1.414L10.414 12l5.293-5.293A1 1 0 0 0 15 5z"/></svg>',
			'<span class="visually-hidden">Další</span><svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true"><path d="M9 5a1 1 0 0 0-.707 1.707L13.586 12l-5.293 5.293a1 1 0 0 0 1.414 1.414l6-6a1 1 0 0 0 0-1.414l-6-6A1 1 0 0 0 9 5z"/></svg>'
		],
		merge: true,
		responsiveClass: true,
		responsive: {
			0: {
				items: 2.3,
				margin: 12
			},
			400: {
				items: 3.3,
				margin: 18
			},
			600: {
				items: 4,
				margin: 20
			},
			1200: {
				items: 4,
				margin: 20
			}
		}
	},
	".carousel-teaser": {
		loop: true,
		dots: true,
		nav: false,
		lazyLoad: false,
		navText: [
			'<span class="visually-hidden">Předchozí</span><svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true"><path d="M15 5a1 1 0 0 0-.707.293l-6 6a1 1 0 0 0 0 1.414l6 6a1 1 0 0 0 1.414-1.414L10.414 12l5.293-5.293A1 1 0 0 0 15 5z"/></svg>',
			'<span class="visually-hidden">Další</span><svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true"><path d="M9 5a1 1 0 0 0-.707 1.707L13.586 12l-5.293 5.293a1 1 0 0 0 1.414 1.414l6-6a1 1 0 0 0 0-1.414l-6-6A1 1 0 0 0 9 5z"/></svg>'
		],
		responsiveClass: true,
		items: 1,
		margin: 0,
		autoplay: false, // Vypnout autoplay dokud se nenačte
		autoplayTimeout: 5000,
		autoplayHoverPause: true,
		animateIn: 'fadeIn',
        animateOut: 'fadeOut',
		onInitialized: function(event) {
            // Spusť autoplay až po inicializaci
            setTimeout(() => {
                $(event.target).trigger('play.owl.autoplay');
            }, 100);
        }
	},
	".carousel-logos": {
		loop: false,
		dots: false,
		nav: true,
		lazyLoad: true,
		navText: [
			'<span class="visually-hidden">Předchozí</span><svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true"><path d="M15 5a1 1 0 0 0-.707.293l-6 6a1 1 0 0 0 0 1.414l6 6a1 1 0 0 0 1.414-1.414L10.414 12l5.293-5.293A1 1 0 0 0 15 5z"/></svg>',
			'<span class="visually-hidden">Další</span><svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true"><path d="M9 5a1 1 0 0 0-.707 1.707L13.586 12l-5.293 5.293a1 1 0 0 0 1.414 1.414l6-6a1 1 0 0 0 0-1.414l-6-6A1 1 0 0 0 9 5z"/></svg>'
		],
		items: 8,
		slideBy: 4,
		margin: 0,
		merge: false,
		autoWidth: true,
		responsiveClass: true
	},
	".carousel-promo": {
		loop: true,
		dots: true,
		nav: false,
		lazyLoad: false,
		navText: [
			'<span class="visually-hidden">Předchozí</span><svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true"><path d="M15 5a1 1 0 0 0-.707.293l-6 6a1 1 0 0 0 0 1.414l6 6a1 1 0 0 0 1.414-1.414L10.414 12l5.293-5.293A1 1 0 0 0 15 5z"/></svg>',
			'<span class="visually-hidden">Další</span><svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true"><path d="M9 5a1 1 0 0 0-.707 1.707L13.586 12l-5.293 5.293a1 1 0 0 0 1.414 1.414l6-6a1 1 0 0 0 0-1.414l-6-6A1 1 0 0 0 9 5z"/></svg>'
		],
		responsiveClass: true,
		items: 1,
		margin: 0,
		autoplay: false, // Vypnout autoplay dokud se nenačte
		autoplayTimeout: 6000,
		autoplayHoverPause: true,
		animateIn: 'fadeIn',
        animateOut: 'fadeOut',
		onInitialized: function(event) {
            // Spusť autoplay až po inicializaci
            setTimeout(() => {
                $(event.target).trigger('play.owl.autoplay');
            }, 100);
        }
	},
};

var DEFAULT_CAROUSEL_CONFIG = {};


/* Připrav mi carousel config a obohať mi ho o default */
if (! CAROUSEL_CONFIG) {
    CAROUSEL_CONFIG = DEFAULT_CAROUSEL_CONFIG;
} else {
    for (var key in DEFAULT_CAROUSEL_CONFIG) {
        if (! CAROUSEL_CONFIG[key]){
            CAROUSEL_CONFIG[key] = DEFAULT_CAROUSEL_CONFIG[key];
        }
    }
}

var initializeCarousels = function () {
    // Použij requestAnimationFrame pro asynchronní inicializaci
    function initNextCarousel(selectors, index = 0) {
        if (index >= selectors.length) return;

        const selector = selectors[index];
        $(selector).owlCarousel(CAROUSEL_CONFIG[selector]);

        // Inicializuj další carousel v dalším frame
        requestAnimationFrame(() => initNextCarousel(selectors, index + 1));
    }

    const selectors = Object.keys(CAROUSEL_CONFIG);
    if (selectors.length > 0) {
        requestAnimationFrame(() => initNextCarousel(selectors));
    }
};



// init
$(document).ready(function () {
	initializeCarousels();
});